// Входной контракт Engine A (spec §1).
//
// Вход — T-поля шага 6 per stage. Источник-агностичен: печать или ASR-чистка
// (см. §1.2), Engine A видит обычный текст. Carrier-флаг приходит из выхода
// System 1 (carrier_stages), передаётся отдельно в selectQuotes (§1.3).

import { FIELDS } from './thresholds.js';

/**
 * Нормализует вход к каноническому массиву этапов.
 *
 * Принимает:
 *   - [{ T1, T2, T3 }]                      (строки; отсутствующее → '')
 *   - [{ t1, t2, t3 }]                      (нижний регистр ключей)
 *
 * Возвращает: { stages: [{ T1, T2, T3 }], n }
 */
export function normalizeStages(input) {
  const raw = Array.isArray(input) ? input : input?.stages;
  if (!Array.isArray(raw) || raw.length === 0) {
    throw new Error('normalizeStages: expected a non-empty array of stages');
  }

  const stages = raw.map((stage) => {
    const out = {};
    for (const F of FIELDS) {
      const v = stage?.[F] ?? stage?.[F.toLowerCase()] ?? '';
      out[F] = typeof v === 'string' ? v.trim() : String(v ?? '').trim();
    }
    return out;
  });

  return { stages, n: stages.length };
}

/**
 * Empty-filter (§2.1, B3 char-count gate убран — D&R s277.d1, floor=0):
 * кандидат — любое НЕПУСТОЕ (после trim) поле. Качественный отсев делает
 * рубрика осмысленности (§3) семантически, не длина — короткие плотные фразы
 * («never», «done», «hate it») валидны и должны дойти до LLM.
 */
export function preEligible(text) {
  return typeof text === 'string' && text.trim().length > 0;
}

/** Поля этапа, прошедшие empty-filter: { F: text }. Пустые отсутствуют. */
export function eligibleFields(stage) {
  const out = {};
  for (const F of FIELDS) {
    if (preEligible(stage[F])) out[F] = stage[F];
  }
  return out;
}
